import React from "react";
import { Grid, Row, Col } from "react-bootstrap";

// utils
// import { get } from "../../../utils/apiService";

// components
import UsersToExcludeTable from "./UsersToExcludeTable";
import UsersToExcludeForm from "./UsersToExcludeForm";

const UsersToExclude = props => (
  <Grid>
    <Row>
      <Col md={12}>
        <UsersToExcludeForm video={props.video} />
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <UsersToExcludeTable video={props.video} />
      </Col>
    </Row>
  </Grid>
);

export default UsersToExclude;



// WEBPACK FOOTER //
// ./src/components/pages/UsersToExclude/index.js